export const tagListItemTypes = {
  REGULAR: '',
  CONTACT_LIST: 'contact-list',
} as const
